import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Icon, Button, Divider, Table, message, Modal, Spin, Input } from 'antd';
import $ from 'jquery';
import _ from 'underscore';
// Styles
import './style.css';

// Assets
import { save_asset, get_assets, delete_assets, update_assets, upload_files, onDocDelete } from './actions/assets.action';

// Children
import NewAsset from './childs/new.assets';
import EditAsset from './childs/edit.assets';

const { confirm } = Modal;
class Assets extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            visibleNewAsset: false,
            visibleEditAsset: false,
            editData: [],
            loading: false,
            filter_device_type: [],
            requestmodal: false,
            searchText: ''
        }

        this.handleNewAAssets = this.handleNewAAssets.bind( this );
        this.handleCancelModal = this.handleCancelModal.bind( this );
        this.handSubmit = this.handSubmit.bind( this );
        this.handEditSubmit = this.handEditSubmit.bind( this );
        this.handleAssetDelete = this.handleAssetDelete.bind( this );
        this.handleDocs = this.handleDocs.bind( this );

    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    handleDocs( e, asset_id ){

        this.setState({ loading: true });

        var fdata = new FormData();

        if( e.target.files.length>0 ){
            $.each( e.target.files, function( i, file ){

                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                fdata.append( "asset_id", asset_id );

            });
        }

        this.props.upload_files( fdata );
    }

    handSubmit( data ){
        this.props.save_asset( data );
    }

    handEditSubmit( data ){
        this.props.update_assets( data );
    }

    handleNewAAssets(){
        this.setState({ visibleNewAsset: true, visibleEditAsset: false });
    }

    handleCancelModal( data ){
        this.setState({ visibleNewAsset: data, visibleEditAsset: data });
    }

    handleAssetDelete( id ){
        
        let self = this;

        confirm({
            title: 'Do you Want to delete these asset?',
            onOk() {
                self.props.delete_assets( id );
            },
            onCancel() {
                // Nothing
            },
        });

    }

    componentWillMount(){
        this.props.get_assets();
    }

    componentWillReceiveProps( nextProps ){
        
        if( nextProps.asset.length !== 0 ){
            
            if( nextProps.asset.STATUS.CODE === "200" & 
                nextProps.asset.STATUS.MESSAGE === "Successfully Listed Assets" ){
                
                let tempData = nextProps.asset.OUTPUT.DATA;
                let tempFilter = [];
                let new_tempFilter = [];

                tempData.map( (item, k) => {
                    tempFilter.push( item.asset_type )
                });

                let filter_list = _.uniq( tempFilter );

                filter_list.map( (item, k) => {
                    new_tempFilter.push( { text: item, value: item })
                });

                this.setState({
                    data: tempData,
                    filter_device_type: new_tempFilter
                });

            }

            if( nextProps.asset.STATUS.CODE === "200" & 
                nextProps.asset.STATUS.MESSAGE === "Documents Uploaded" ){
                this.props.get_assets();
                this.setState({ loading: false });
            }

            if( nextProps.asset.STATUS.CODE === "400" ){
                message.error( nextProps.asset.STATUS.MESSAGE );
            }


        }

    }

    render() {

        const columns = [
            {
                title: 'Device Type',
                dataIndex: 'asset_type',
                key: 'asset_type',
                filters: this.state.filter_device_type,
                onFilter: (value, record) => record.asset_type.includes(value),
            },
            {
                title: 'Device Model',
                dataIndex: 'asset_model',
                key: 'asset_model',
                ...this.getColumnSearchProps( 'asset_model' )
            },
            {
                title: 'Device Serial Number',
                dataIndex: 'asset_serial',
                key: 'asset_serial',
                ...this.getColumnSearchProps( 'asset_serial' )
            },
            {
                title: 'DV Serial Number',
                dataIndex: 'dv_asset_serial',
                key: 'dv_asset_serial',
                ...this.getColumnSearchProps( 'dv_asset_serial' )
            },
            {
                title: 'Notes',
                dataIndex: 'notes',
                key: 'notes',
            },
            {
                title: 'Action',
                width: '20%',
                render: (data) => <span>
                    <Button size={'small'} type="primary" onClick={ (e) => this.setState({ editData: data, visibleEditAsset: true }) } >Edit</Button>&nbsp;
                    <Button size={'small'} type="danger" onClick={ (e) => this.handleAssetDelete( data.asset_id ) } >Delete</Button>
                </span>
            },
        ];


        return (
            <div className="assets_wrapper">
                
                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="container" />
                            &nbsp; Assets
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ this.handleNewAAssets }
                            className="fl_right" type="primary" icon="plus">Add Assets</Button>
                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <Spin spinning={this.state.loading} >
                            <Table columns={ columns } 
                                dataSource={ this.state.data }
                                expandedRowRender={ data => 
                                <div style={{ margin: 0 }}>
                                        <label>Upload Files</label>
                                        <input
                                            multiple style={{ margin: '10px auto' }} type="file"
                                            onChange={ ( e )=> this.handleDocs( e, data.asset_id ) } />

                                        <div className="file_wrapper">
                                            <ul> 
                                                { data.docs.map( (item,i) => 
                                                    <li>
                                                        <span style={{paddingRight: '10px'}}>{ item.document_name }</span>
                                                        <div className="fl_right">
                                                        <Button size="small" icon="delete" className="fl_right mrg_t_10 mrg_r_10" onClick={ ()=> this.props.onDocDelete( item.asset_doc_id, item.document_name )} type="danger"></Button>
                                                        <a href={ item.document_path } target="_blank">
                                                            <Button size="small" icon="cloud-download" className="fl_right mrg_t_10 mrg_r_10"></Button>
                                                        </a></div>
                                                    </li> 
                                                ) }
                                            </ul>
                                        </div>
                                </div>}
                            />
                        </Spin>
                    </Col>
                </Row>

                <NewAsset 
                    onModel={ this.state.visibleNewAsset } onCancel={ this.handleCancelModal } onSubmit={ this.handSubmit } />
                
                <EditAsset 
                    onData={ this.state.editData }
                    onModel={ this.state.visibleEditAsset } onCancel={ this.handleCancelModal } onSubmit={ this.handEditSubmit } />
                

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        asset: state.asset
    }
}

export default connect( mapStatetoProps, { save_asset, get_assets, delete_assets, update_assets, upload_files, onDocDelete } )( Assets );



// WEBPACK FOOTER //
// ./src/pages/assets/index.js